"use strict";
import _ from "underscore";
const lineItemsForCalculation = (lineItems, ignoreAdjustmentLineItems) => {
  return _.select(lineItems, (li) => {
    if (ignoreAdjustmentLineItems) {
      return !li.data.from_adjustment_price_sheet;
    } else {
      return true;
    }
  });
};
export default lineItemsForCalculation;
